import { kpiService } from '_services';
import { ACTIONS_KPI } from '_constants/kpi.constants';
import alertActions from './alert.actions';

export const receiveKpis = (kpis) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < kpis.length; i++) {
    byIdObjectToDispatch[kpis[i].id] = kpis[i];
  }

  return {
    type: ACTIONS_KPI.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteKpi = (kpiId) => ({
  type: ACTIONS_KPI.DELETE,
  byId: { [kpiId]: null }
});

const getKpis = () => async (dispatch) => {
  try {
    const resp = await kpiService.getAll();

    // NOTE: This is used by globals controller which isn't mapping to a DTO. Should be kpiID.
    if (resp?.[0]?.id) {
      dispatch(receiveKpis(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving kpis.', e));
  }
  return null;
};

const kpiActions = {
  getKpis,
};

export default kpiActions;
